import React from "react";
import CountryFieldContainer from "../../ui/layout/page/forms-container/form-item-container/country-field-container";
import DateFieldContainer from "../../ui/layout/page/forms-container/form-item-container/date-field-container";
import InputContainer from "../../ui/layout/page/forms-container/form-item-container/input-container";
import AddressSelect from "../shared/components/address-select";
import BirthDate from "../shared/components/birth-date";
import Country from "../shared/components/country";
import FirstName from "../shared/components/first-name";
import Gender from "../shared/components/gender";
import LastName from "../shared/components/last-name";
import Nationality from "../shared/components/nationality";
import { DEFAULT_COUNTRY } from "../shared/types";
import { Grid } from "@mui/material";
import { OwnerType } from "./types";

interface PersonsProps {
  owner: OwnerType;
  dataPath: string;
}

export default function Person({
  owner,
  dataPath = "",
}: PersonsProps): React.JSX.Element {
  return (
    <Grid
      className="scd-container-base"
      container
      size={{ xs: 12 }}
      key={dataPath}
    >
      <Gender dataPath={dataPath} />
      <InputContainer>
        <FirstName dataPath={dataPath} value={owner?.firstName} />
      </InputContainer>
      <InputContainer>
        <LastName dataPath={dataPath} value={owner?.lastName} />
      </InputContainer>
      <DateFieldContainer>
        <BirthDate dataPath={dataPath} value={owner?.birthdate} />
      </DateFieldContainer>
      <CountryFieldContainer>
        <Nationality dataPath={dataPath} value={owner?.nationality} />
      </CountryFieldContainer>
      <AddressSelect
        fullStreet={owner?.fullStreet}
        address={owner?.address}
        dataPath={dataPath}
      />
      <InputContainer>
        <Country
          dataPath={dataPath}
          value={
            owner?.address
              ? owner?.address.country
              : { alpha2: DEFAULT_COUNTRY }
          }
        />
      </InputContainer>
    </Grid>
  );
}
